import { Resource as ResourceType } from '../types';

export const subCategory: ResourceType = {
  name: 'sub_categories',
  label: 'resource.categories.label',
  hideResource: true,
  attributes: [
    {
      key: 'id',
      label: 'resource.candidates.field.id.label',
      type: 'text',
    },
    {
      key: 'name',
      label: 'resource.candidates.field.name.label',
      type: 'text',
    },
    {
      key: 'sub_categories_name_phrase',
      label: 'resource.candidates.field.name.label',
      type: 'text',
    },
  ],
  pages: {
    list: {
      hasEditButton: true,
      hasCreateButton: false,
      fields: [],
    },
    edit: {
      left: {
        tabs: [
          {
            key: '',
            title: '',
            sections: [
              {
                key: '',
                title: '',
                layout: [],
                inputs: {},
                fields: {},
              },
            ],
          },
        ],
      },
    },
  },
};
